import Vue from 'vue';
import {
  Actionsheet,
  Button,
  Cell,
  CellGroup,
  Col,
  Checkbox,
  Dialog,
  Field,
  Loading,
  List,
  Icon,
  Picker,
  Popup,
  Row,
  Step,
  Steps,
  SubmitBar,
  Tab,
  Tabs,
  Tabbar,
  TabbarItem,
  Toast,
} from 'vant';
import 'vant/lib/vant-css/icon-local.css';
import 'vant/packages/vant-css/src/button.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMobileAlt, faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './App.vue';
import router from './router';
import store from './store';
import HTTP from './libs/HTTP';
import { apiURL } from './libs/const';
import './registerServiceWorker';
import './styles/bootstrap.scss';

Vue.use(Actionsheet)
  .use(Button)
  .use(Cell)
  .use(CellGroup)
  .use(Col)
  .use(Checkbox)
  .use(Dialog)
  .use(Field)
  .use(Loading)
  .use(List)
  .use(Icon)
  .use(Picker)
  .use(Popup)
  .use(Row)
  .use(Step)
  .use(Steps)
  .use(SubmitBar)
  .use(Tab)
  .use(Tabs)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Toast);

library.add(faMobileAlt);
library.add(faLock);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.prototype.$http = new HTTP(apiURL);

Vue.config.productionTip = false;

const app = new Vue({
  router,
  store,
  components: {
    App,
  },
  render: h => h(App),
});

window.mountApp = () => {
  app.$mount('#app');
};

window.mountApp();
